import paya from "../assets/images/mutton-paya.jpg";
import marag from "../assets/images/marag.jpg"

import haleem from "../assets/images/res-haleem(copy).jpg";
import ChickenHaleem from "../assets/images/res-haleem-chicken(copy).jpg";

import mirchi from "../assets/images/res-mirchi(copy).jpg";
import samosa from "../assets/images/res-samosa(copy).jpg";
import onionPakoda from "../assets/images/onion-pakoda.jpg";
import alooBajji from "../assets/images/aloo-bajji.jpg";
import gobi65 from "../assets/images/gobi65.jpg";
import crispyCorn from "../assets/images/crispy-corn.jpg";
import chilliPaneer from "../assets/images/chilli-paneer.jpg";
import gobiManchurian from "../assets/images/gobi-manchurian.jpg";
import paneerManchurian from "../assets/images/paneer-manchurian.jpg";
import vegManchurian from "../assets/images/veg-manchurian.jpg";

import chicken65 from "../assets/images/Chicken-65.jpg";
import chickenManchurian from "../assets/images/chicken-manchurian.jpg";
import gingerChicken from "../assets/images/ginger-chicken.jpg";
import lemonChicken from "../assets/images/lemon-chicken.jpg";
import chilliChicken from "../assets/images/chilli-chicken.jpg";
import majesticChicken from "../assets/images/majestic-chicken.jpg";
import pepperChicken from "../assets/images/pepper-chicken.jpg";
import karvepakuChicken from "../assets/images/karvepaku-chicken.jpg";
import apolloFish from "../assets/images/apollo-fish.jpg";
import liverFry from "../assets/images/liver-fry.jpg";

import biryani from "../assets/images/res-biryani(copy).jpg";
import muttonBiryani from "../assets/images/mutton-biryani.jpg";
import guttivankayaBiryani from "../assets/images/guttivankaya-biryani.jpg";
import gonguraMuttonBiryani from "../assets/images/gonguramutton-biryani.jpg";
import chickenGheeRoastBiryani from "../assets/images/chickenGheeRoast-biryani.jpg";
import keemaBiryani from "../assets/images/keema-biryani.jpg";
import vegBiryani from "../assets/images/veg-biryani.jpg";
import chicken65Biryani from "../assets/images/chicken-65-biryani.jpg";
import biryaniRice from "../assets/images/biryani-rice.jpg";
import eggBiryani from "../assets/images/egg-biryani.jpg";
import paneerBiryani from "../assets/images/paneer-biryani.jpg";

import schezwanVegRice from "../assets/images/schewanVeg-rice.jpg";
import schezwanChickenRice from "../assets/images/schezwanChicken-rice.jpg";
import schezwanVegNoodles from "../assets/images/schezwanVeg-noodles.jpg";
import schezwanChickenNoodles from "../assets/images/schezwanChicken-noodles.jpg";
import vegFriedRice from "../assets/images/vegFried-rice.jpg";
import eggFriedRice from "../assets/images/eggFried-rice.jpg";

import dalTadka from "../assets/images/dal-tadka.jpg";
import kattiDal from "../assets/images/katti-dal.jpg";
import Dalmakhani from "../assets/images/dal-makhani.jpg";
import dumAloo from "../assets/images/dum-aloo.jpg";
import bhendiMasala from "../assets/images/bhendi-masala.jpg";
import paneerPyaza from "../assets/images/paneer-pyaza.jpg";
import paneerLababdar from "../assets/images/paneer-lababdar.jpg";
import chanaMasala from "../assets/images/chana-masala.jpg";
import eggMasala from "../assets/images/egg-masala.jpg";
import chapathi from "../assets/images/chapathi.jpg";
import rice from "../assets/images/rice.jpg";

import dumKaMurgh from "../assets/images/dum-ka-murgh.jpg";
import kadaiChicken from "../assets/images/Kadai-Chicken.jpg";
import chickenKorma from "../assets/images/chicken-korma.jpg";
import muttonCurry from "../assets/images/mutton-curry.jpg";
import chickenCurry from "../assets/images/andhra-chicken-curry.jpg";
import fishCurry from "../assets/images/fish-curry.jpg";
import gonguraMutton from "../assets/images/gongura-mutton.jpg";
import prawnsCurry from "../assets/images/prawns-curry.jpg";
import butterChicken from "../assets/images/butter-chicken.jpg";
import gonguraChickenCurry from "../assets/images/gongura-chicken.jpg";
import brinjalCurry from "../assets/images/brinjal-curry.jpg";
import paneerCurry from "../assets/images/paneer-curry.jpg";

//import soup from "../assets/images/soup.jpeg";
import Gulabjamun from "../assets/images/res-gulabjamun(1).jpg";
import dessert from "../assets/images/dessert.jpg";
import QubaniKaMeeta from "../assets/images/res-Qubani-ka-meeta.jpg";
import gilEFirdaus from "../assets/images/gil-e-firdaus.jpg";
import tea from "../assets/images/tea.jpg";
import masalaChai from "../assets/images/masala-chai.jpg";
import pop from "../assets/images/pop.jpg";
import waterBottle from "../assets/images/water-bottle.jpg";
import mangoLassi from "../assets/images/mango-lassi.jpg";

export default {
  imageCardData: [],
  menu: {
    "Soup": [
      {
        itemName: "Paya",
        price: "CA $10.00",
        imageUrl: paya,
      },
      {
        itemName: "Marag",
        price: "CA $12.00",
        imageUrl: marag,
      },
    ],
    Haleem: [
      {
        itemName: "Veg Haleem",
        price: "CA $11.99",
        imageUrl: haleem,
      },
      {
        itemName: "Lamb Haleem",
        price: "CA $12.99",
        imageUrl: ChickenHaleem,
      },
    ],
    "Appetizers-Veg": [
      {
        itemName: "Mirchi Bhajji (4 pcs)",
        price: "CA $3.50",
        imageUrl: mirchi,
      },
      {
        itemName: "Veg Samosa (2 pcs)",
        price: "CA $2.00",
        imageUrl: samosa,
      },
      {
        itemName: "Onion Pakoda",
        price: "CA $7.00",
        imageUrl: onionPakoda,
      },
      {
        itemName: "Potato Bhajji",
        price: "CA $6.00",
        imageUrl: alooBajji,
      },
      {
        itemName: "Gobi 65 dry/wet",
        price: "CA $10.99/$11.99",
        imageUrl: gobi65,
      },
      {
        itemName: "Crispy baby corn",
        price: "CA $11.99",
        imageUrl: crispyCorn,
      },
      {
        itemName: "Chilli paneer",
        price: "CA $12.99",
        imageUrl: chilliPaneer,
      },
      {
        itemName: "Gobi manchurian dry/wet",
        price: "CA $10.99/$11.99",
        imageUrl: gobiManchurian,
      },
      {
        itemName: "Paneer manchurian dry/wet",
        price: "CA $11.99/$12.99",
        imageUrl: paneerManchurian,
      },
      {
        itemName: "Veg manchurian dry/wet",
        price: "CA $10.99/$11.99",
        imageUrl: vegManchurian,
      },
    ],
    "Appitizers-Non Veg": [
      {
        itemName: "Chicken 65 dry/wet",
        price: "CA $12.00/$13.00",
        imageUrl: chicken65,
      },
      {
        itemName: "Chicken manchurian dry/wet",
        price: "CA $12.00/$13.00",
        imageUrl: chickenManchurian,
      },
      {
        itemName: "Ginger chicken",
        price: "CA $12.99",
        imageUrl: gingerChicken,
      },
      {
        itemName: "Lemon chicken",
        price: "CA $12.00",
        imageUrl: lemonChicken,
      },
      {
        itemName: "Chilli chicken",
        price: "CA $12.00",
        imageUrl: chilliChicken,
      },
      {
        itemName: "Magestic chicken",
        price: "CA $11.99",
        imageUrl: majesticChicken,
      },
      {
        itemName: "Pepper chicken",
        price: "CA $11.99",
        imageUrl: pepperChicken,
      },
      {
        itemName: "Karvepaku chicken",
        price: "CA $12.00",
        imageUrl: karvepakuChicken,
      },
      {
        itemName: "Apollo Fish",
        price: "CA $13.00",
        imageUrl: apolloFish,
      },
      {
        itemName: "Chicken Samosa (2 pcs)",
        price: "CA $3.00",
        imageUrl: samosa,
      },
      {
        itemName: "Liver Fry",
        price: "CA $11.99",
        imageUrl: liverFry,
      },
    ],
    "Biryani's": [
      {
        itemName: "Possible Biryani",
        price: "CA $12.99",
        imageUrl: vegBiryani,
      },
      {
        itemName: "Vegetable Dum Biryani",
        price: "CA $11.99",
        imageUrl: vegBiryani,
      },
      {
        itemName: "Egg Dum Biryani",
        price: "CA $10.99",
        imageUrl: eggBiryani,
      },
      {
        itemName: "Paneer Biryani",
        price: "CA $10.99",
        imageUrl: paneerBiryani,
      },
      {
        itemName: "Paneer kaju Biryani",
        price: "CA $12.99",
        imageUrl: paneerBiryani,
      },
      {
        itemName: "Guttivankaya Biryani",
        price: "CA $12.99",
        imageUrl: guttivankayaBiryani,
      },
      {
        itemName: "Kachi Gosht ki Dum Biryani",
        price: "CA $13.99",
        imageUrl: muttonBiryani,
      },
      {
        itemName: "Gongura lamb Biryani",
        price: "CA $14.99",
        imageUrl: gonguraMuttonBiryani,
      },
      {
        itemName: "Chicken Dum Biryani",
        price: "CA $12.99",
        imageUrl: biryani,
      },
      {
        itemName: "Chicken 65 with Biryani",
        price: "CA $13.99",
        imageUrl: chicken65Biryani,
      },
      {
        itemName: "Ghee Roast chicken kaju Biryani",
        price: "CA $12.99",
        imageUrl: chickenGheeRoastBiryani,
      },
      {
        itemName: "Kheema Biryani",
        price: "CA $13.99",
        imageUrl: keemaBiryani,
      },
      {
        itemName: "Biryani Rice",
        price: "CA $6.00",
        imageUrl: biryaniRice,
      },
    ],
    "Fried Rice/Noodles": [
      {
        itemName: "Schezwan fried rice veg",
        price: "CA $12.99",
        imageUrl: schezwanVegRice,
      },
      {
        itemName: "Schezwan fried rice chicken",
        price: "CA $13.99",
        imageUrl: schezwanChickenRice,
      },
      {
        itemName: "Schezwan noodles veg",
        price: "CA $11.99",
        imageUrl: schezwanVegNoodles,
      },
      {
        itemName: "Schezwan noodles chicken",
        price: "CA $13.99",
        imageUrl: schezwanChickenNoodles,
      },
      {
        itemName: "Vegetable fried rice",
        price: "CA $12.00",
        imageUrl: vegFriedRice,
      },
      {
        itemName: "Egg fried rice",
        price: "CA $12.00",
        imageUrl: eggFriedRice,
      },
    ],
    "Veg Curries": [
      {
        itemName: "Hyderabadi Bagara Baingan",
        price: "CA $10.99",
        imageUrl: brinjalCurry,
      },
      {
        itemName: "Dal Tadka",
        price: "CA $8.99",
        imageUrl: dalTadka,
      },
      {
        itemName: "Katti dal hyderabadi style",
        price: "CA $10.99",
        imageUrl: kattiDal,
      },
      {
        itemName: "Dal Makhani",
        price: "CA $10.99",
        imageUrl: Dalmakhani,
      },
      {
        itemName: "Dum aloo",
        price: "CA $10.99",
        imageUrl: dumAloo,
      },
      {
        itemName: "Bhendi masala",
        price: "CA $11.99",
        imageUrl: bhendiMasala,
      },
      {
        itemName: "Hyderabadi paneer curry",
        price: "CA $11.99",
        imageUrl: paneerCurry,
      },
      {
        itemName: "Paneer do pyaza",
        price: "CA $11.99",
        imageUrl: paneerPyaza,
      },
      {
        itemName: "Paneer lababdar",
        price: "CA $12.99",
        imageUrl: paneerLababdar,
      },
      {
        itemName: "Channa masala",
        price: "CA $11.99",
        imageUrl: chanaMasala,
      },
      {
        itemName: "Egg curry masala",
        price: "CA $10.99",
        imageUrl: eggMasala,
      },
      {
        itemName: "Chapati",
        price: "CA $1.25",
        imageUrl: chapathi,
      },
      {
        itemName: "Steam rice",
        price: "CA $4.00",
        imageUrl: rice,
      },
    ],
    "Non-Veg Curries": [
      {
        itemName: "Dum ka murgh",
        price: "CA $12.99",
        imageUrl: dumKaMurgh,
      },
      {
        itemName: "kadai Chicken",
        price: "CA $12.99",
        imageUrl: kadaiChicken,
      },
      {
        itemName: "Butter Chicken",
        price: "CA $12.99",
        imageUrl: butterChicken,
      },
      {
        itemName: "Andhra Chicken Curry",
        price: "CA $12.99",
        imageUrl: chickenCurry,
      },
      {
        itemName: "Ghee roast Chicken kaju curry",
        price: "CA $12.99",
        imageUrl: butterChicken,
      },
      {
        itemName: "Homestyle Chicken curry",
        price: "CA $11.99",
        imageUrl: chickenCurry,
      },
      {
        itemName: "Gongura Chicken curry",
        price: "CA $12.99",
        imageUrl: gonguraChickenCurry,
      },
      {
        itemName: "Hyderabadi Chicken korma",
        price: "CA $13.99",
        imageUrl: chickenKorma,
      },
      {
        itemName: "Mutton curry",
        price: "CA $14.99",
        imageUrl: muttonCurry,
      },
      {
        itemName: "Gongura lamb curry",
        price: "CA $15.99",
        imageUrl: gonguraMutton,
      },
      {
        itemName: "Prawns Curry",
        price: "CA $15.99",
        imageUrl: prawnsCurry,
      },
      {
        itemName: "Chapala Pulusu (Fish Curry)",
        price: "CA $14.99",
        imageUrl: fishCurry,
      },
    ],
    Dessert: [
      {
        itemName: "Gulab Jamun",
        price: "CA $2.00",
        imageUrl: Gulabjamun,
      },
      {
        itemName: "Double Ka Meetha",
        price: "CA $4.50",
        imageUrl: dessert,
      },
      {
        itemName: "Qubani ka Meetha",
        price: "CA $5.00",
        imageUrl: QubaniKaMeeta,
      },
      {
        itemName: "Gil-e-firdaus",
        price: "CA $5.99",
        imageUrl: gilEFirdaus,
      },
    ],
    Beverages: [
      {
        itemName: "Irani Chai",
        price: "CA $3.50",
        imageUrl: tea,
      },
      {
        itemName: "Masala Chai",
        price: "CA $3.50",
        imageUrl: masalaChai,
      },
      {
        itemName: "Assorted Pop",
        price: "CA $1.50",
        imageUrl: pop,
      },
      {
        itemName: "Water Bottle",
        price: "CA $1.50",
        imageUrl: waterBottle,
      },
      {
        itemName: "Mango Lassi",
        price: "CA $3.99",
        imageUrl: mangoLassi,
      },
    ],
  },
  reviews: [
    {
      imageUrl: "",
      reviewerName: "Niz M",
      review:
        "Authentic Hyderabadi food. We ordered Haleem which was amazing and authentic taste, mutton Biryani was awesome, baigan ka bagara was exactly like home cooked. Mirchi bajji was great as well. We tried many restaurants and this was the best Haleem we had in GTA. Overall the best Hyderabadi food you can have in GTA. Highly recommended.",
    },
    {
      imageUrl: "",
      reviewerName: "Ritesh M",
      review:
        "If you’re in mood of biryani, this is amongst the best place for you guys!! Had chicken 65 and dum biryani and trust me it had the authentic Hyderabadi taste. It was lip smacking good. The owner is so sweet too. I would highly recommend this place. 10/10 in taste.",
    },
    {
      imageUrl: "",
      reviewerName: "DLK",
      review:
        "We had Egg Biryani which was very tasty. The best part is there is no oil which is very good for health. Happy place to pick up and eat. The Irani Chai is also amazing! Eat here and you will not miss Hyderabad!!!",
    },
  ],
  features: [
    {
      icon: "menu",
      title: "Menu for every taste",
      content: "With a wide variety of menu, we have a dish for every taste",
    },
    {
      icon: "produce",
      title: "Always fresh ingredients",
      content:
        "We prepare our dishes with fresh ingredients right from the market",
    },
    {
      icon: "chef",
      title: "Experienced chefs",
      content: "Our experienced chefs serve you the best dishes of your choice",
    },
  ],
  timings: [
    {
      day: "Monday",
      hours: "Holiday",
    },
    {
      day: "Tuesday",
      hours: "12:00pm to 9:00pm",
    },
    {
      day: "Wednesday",
      hours: "12:00pm to 9:00pm",
    },
    {
      day: "Thursday",
      hours: "12:00pm to 9:00pm",
    },
    {
      day: "Friday",
      hours: "12:00pm to 10:00pm",
    },
    {
      day: "Saturday",
      hours: "12:00pm to 10:00pm",
    },
    {
      day: "Sunday",
      hours: "12:00pm to 8:00pm",
    },
  ],
  notification: {
    showNotification: true,
    content: "*** Enjoy hot bowl of haleem all round the year ***",
  },
};
